import { render, staticRenderFns } from "./Pilot.vue?vue&type=template&id=304652ff&"
import script from "./Pilot.vue?vue&type=script&lang=js&"
export * from "./Pilot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304652ff')) {
      api.createRecord('304652ff', component.options)
    } else {
      api.reload('304652ff', component.options)
    }
    module.hot.accept("./Pilot.vue?vue&type=template&id=304652ff&", function () {
      api.rerender('304652ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Pilot.vue"
export default component.exports